export const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const SHADOW_TIME_FORMAT = 'HH:mm'
export const RENDER_TIME_FORMAT = 'h:mm a'
export const EDIT_TIME_FORMAT = 'hh:mm A'
